import { amber } from '@mui/material/colors';

export const MAX_CHARS = 1000;

export const reviewModalNotesStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: amber[50],
		borderRadius: 1,
		p: 2,
		width: '100%',
		gap: 1,
		position: 'relative'
	},

	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between'
	},

	notesLabel: {
		fontWeight: 600,
		fontSize: '0.875rem',
		color: 'text.primary'
	},

	notesText: {
		fontSize: '0.875rem'
	},

	limitLabelContainer: {
		display: 'flex',
		justifyContent: 'flex-end'
	},

	limitLabel: (currentLength: number) => ({
		color: currentLength >= MAX_CHARS ? 'error.main' : 'text.secondary',
		fontWeight: currentLength >= MAX_CHARS ? 600 : 400
	})
};
